import React from 'react';
import { alpha, styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import MuiCardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Favourite from './Favouirte';
import Stack from '@mui/material/Stack';

const StyledDivider = styled(Divider)(({ theme }) => ({
  flex: `1 0 auto`,
  width: `100%`,
  minHeight: theme.spacing(1),
  backgroundColor: alpha(theme.palette.secondary.main, 0.35)
}))

const StyledVertivalDivider = styled(Divider)(({ theme }) => ({
  height: `100%`,
  backgroundColor: alpha(theme.palette.secondary.main, 0.35)
}))


export default function CardContent(props) {

  const { cardData } = props

  return (
    <React.StrictMode>

      <MuiCardContent>
        <Stack spacing={1}>
          <Stack direction="row" spacing={2}>

            <Typography
              align="left"
              color="textPrimary"
              gutterBottom
              variant="h5"
            // noWrap
            >
              {cardData.title.trim().length > 0 ? cardData.title : <>Product title missing</>}
            </Typography>

            <Favourite {...props} />

          </Stack>
          <StyledDivider />
          <Typography
            align="center"
            color="textPrimary"
            gutterBottom
            variant="h6"
          >
            {cardData.ownerName != null && cardData.ownerName.trim() != "" ?
              cardData.ownerName : <>Product Owner Info Missing</>
            }
          </Typography>
          <StyledDivider />
          <Stack direction="row" spacing={2}>
            <Typography
              align="center"
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              {Array.isArray(cardData.market) ? cardData.market[0]['name']
                : (typeof cardData.market === 'object' && cardData.market != null) ? cardData.market['name']
                  : cardData.market.length > 0 ? cardData.market : <>Market Info Missing</>
              }
            </Typography>
            <StyledVertivalDivider orientation="vertical" flexItem />
            <Typography
              align="center"
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              {Array.isArray(cardData.region) && cardData.region.length > 0 ? cardData.region[0]['name']
                : (typeof cardData.region === 'object' && cardData.market != null) ? cardData.region['name']
                  : cardData.region.length > 0 ? cardData.region : <>Region Info Missing</>
              }
            </Typography>
          </Stack>
          <StyledDivider />
          <Typography
            align="center"
            color="textSecondary"
            gutterBottom
            variant="body2"
          > Platform: {Array.isArray(cardData.platform) && cardData.platform.length > 0 ? cardData.platform[0]['name'] : (typeof cardData.platform === 'object') ? cardData.platform['name'] : cardData.platform
            }
          </Typography>
          <StyledDivider />
        </Stack>
      </MuiCardContent >
    </React.StrictMode>

  );
}

